import React from "react";
import Marquee from "react-fast-marquee";
import PropTypes from "prop-types";
import SitePicture, { clientLogoName } from "./SitePicture";

const ClientCarousel = ({
  logos,
  direction,
  speed,
  pauseOnHover,
  gradient,
}) => {
  return (
    <div className="w-full overflow-hidden">
      <Marquee
        direction={direction}
        speed={speed}
        pauseOnHover={pauseOnHover}
        gradient={gradient}
      >
        {logos.map((logo, index) => (
          <div key={index} className="inline-block px-6">
            <SitePicture
              name={clientLogoName(logo.image)}
              alt={logo.name || `Logo ${index + 1}`}
              sizes="120px"
              className="h-20 w-auto object-contain"
            />
          </div>
        ))}
      </Marquee>
    </div>
  );
};

ClientCarousel.propTypes = {
  logos: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      name: PropTypes.string,
    })
  ).isRequired,
  direction: PropTypes.oneOf(["left", "right"]),
  speed: PropTypes.number,
  pauseOnHover: PropTypes.bool,
  gradient: PropTypes.bool,
};

export default ClientCarousel;
